import type { AxiosResponse } from "axios";
import { wooCustomApi } from "@/api/clients/wooCustomApiClient";
import type {
  CreateECPayPaymentRequestPayload,
  ECPayCVSMapRequestPayload,
  GetOrderAdditionalInfoRequestParams,
  GetOrderDetailsRequestParams,
} from "@/types/api/wooCustomApi";
import type { OrderDetails, OrderResultAdditionalInfo } from "@/types/order";

const wooCustomApiService = {
  ecpay: {
    payment: {
      createOrder: async (
        order_id: string,
        payload: CreateECPayPaymentRequestPayload,
        signal?: AbortSignal,
      ) => {
        try {
          const response = await wooCustomApi.post(
            `v1/ecpay/payment/order/${order_id}`,
            payload,
            { signal },
          );
          return response as AxiosResponse<string>; // form html
        } catch (error) {
          throw error;
        }
      },
    },

    shipping: {
      cvsMap: async (
        payload: ECPayCVSMapRequestPayload,
        signal?: AbortSignal,
      ) => {
        try {
          const response = await wooCustomApi.post(
            "v1/ecpay/shipping/cvs-map",
            payload,
            { signal },
          );
          return response as AxiosResponse<string>; // form html
        } catch (error) {
          throw error;
        }
      },
    },
  },

  order: {
    getAdditionInfo: async (
      orderId: number,
      params: GetOrderAdditionalInfoRequestParams,
      signal?: AbortSignal,
    ) => {
      try {
        const response = await wooCustomApi.get(
          `/v1/order-additional-info/${orderId}`,
          {
            params,
            signal,
          },
        );
        return response as AxiosResponse<OrderResultAdditionalInfo>;
      } catch (error) {
        throw error;
      }
    },

    getOrderDetails: async (
      order_id: number,
      params: GetOrderDetailsRequestParams,
    ) => {
      try {
        const response = await wooCustomApi.get(`/v1/order/${order_id}`, {
          params,
        });
        return response as AxiosResponse<OrderDetails>;
      } catch (error) {
        throw error;
      }
    },
  },
};

export default wooCustomApiService;

